import runnerEpicsMap from "./runner.epics";
import * as runnerReducers from "./runner.reducers";
import { objectValues } from "@ea/shared_components/utils/object";

const runnerEpics = objectValues(runnerEpicsMap);

export { runnerReducers, runnerEpics };
